import React, { PropTypes } from 'react';
import AnimatedButton from 'common/components/animated_button';

const SaveProfileButton = ({ saveProfile, isSaving }) => (
  <div className="header-controls button-wrapper">
    <AnimatedButton
      processing={isSaving}
      type="submit"
      label="Save"
      onClick={saveProfile}
      processingLabel="Saving..."
    />
  </div>
);

SaveProfileButton.propTypes = {
  saveProfile: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};

export default SaveProfileButton;
